import { render, staticRenderFns } from "./FormiumReplyHtml.vue?vue&type=template&id=90164884"
import script from "./FormiumReplyHtml.vue?vue&type=script&lang=js"
export * from "./FormiumReplyHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports